import React, { useEffect, useMemo, useState } from "react";
import Chart from "react-apexcharts";
import { Card } from "react-bootstrap";
import analyticsService from "../../redux/services/analytics.service";

const TotalSalesOverview = ({ from, to, storeId }) => {
  const [loading, setLoading] = useState(true);
  const [totals, setTotals] = useState(null);
  const [byDay, setByDay] = useState([]);

  useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true);
      try {
        const res = await analyticsService.overview({ from, to, storeId });
        const d = res.data?.data ?? res.data;
        if (!alive) return;
        setTotals(d?.totals ?? null);
        setByDay(Array.isArray(d?.byDay) ? d.byDay : []);
      } catch {
        if (!alive) return;
        setTotals(null);
        setByDay([]);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, [from, to, storeId]);

  const options = useMemo(
    () => ({
      chart: { type: "area", toolbar: { show: false } },
      xaxis: { categories: byDay.map((d) => d.day) },
      dataLabels: { enabled: false },
      stroke: { curve: "smooth" },
      title: { text: "Total Sales Overview", align: "left" },
    }),
    [byDay]
  );

  const series = useMemo(() => {
    const points = byDay.map((d) => Number(d.netSales ?? d.total ?? 0) || 0);
    return [{ name: "Net Sales (₹)", data: points }];
  }, [byDay]);

  return (
    <Card className="mb-4 shadow-sm">
      <Card.Body>
        <div className="d-flex flex-wrap gap-2 align-items-baseline justify-content-between mb-2">
          <div className="small text-muted">
            {loading ? "Loading…" : `Net Sales: ₹${Number(totals?.netSales ?? 0) || 0}`}
          </div>
          <div className="small text-muted">
            Orders: {Number(totals?.ordersTotal ?? 0) || 0} · Delivered: {Number(totals?.ordersDelivered ?? 0) || 0}
          </div>
        </div>
        <Chart options={options} series={series} type="area" height={300} />
      </Card.Body>
    </Card>
  );
};

export default TotalSalesOverview;
